import { Box, Flex, Text, Link } from "@chakra-ui/react";
import React from "react";

interface FooterProps {
    color?: string;
    linkColor?: string;
}

export default function Footer({ color = "gray.600", linkColor = "blue.500" }: FooterProps) {
    return (
        <Box as="footer" py="4" textAlign="center" width="100%" color={color} fontSize="sm">
            <Flex direction="column" align="center" justify="center">
                <Text mb="1">
                    &copy; {new Date().getFullYear()} IEP Management System - National Federation of the Deaf (NDFN)
                </Text>
                <Text>
                    Software developed and Maintained by:{" "}
                    <Link href="https://diversepatterns.com.np" isExternal color={linkColor}>
                        Diverse Patterns
                    </Link>
                </Text>
            </Flex>
        </Box>
    );
}
